import React from 'react';

import { Classes, Dialog } from "@blueprintjs/core";

import './index.css';

const Modal = ({ children, hideHeader, onRequestClose, renderFooter, ...props }) => {
    return (
        <Dialog
            icon="info-sign"
            onClose={onRequestClose}
            {...props}
        >
            <div className={Classes.DIALOG_BODY}>
                {children}
            </div>
            <div className={Classes.DIALOG_FOOTER}>
                <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                    {renderFooter && renderFooter()}
                </div>
            </div>
        </Dialog>
    );
};

export default Modal;